const clients = [
  { src: "/images/clientes/1.jpg", alt: "Cliente 1" },
  { src: "/images/clientes/2.jpg", alt: "Cliente 2" },
  { src: "/images/clientes/3.jpg", alt: "Cliente 3" },
  { src: "/images/clientes/4.jpg", alt: "Cliente 4" },
  { src: "/images/clientes/5.png", alt: "Cliente 5" },
  { src: "/images/clientes/6.jpg", alt: "Cliente 6" },
  { src: "/images/clientes/7.png", alt: "Cliente 7" },
];

export default function Clients() {
  const doubled = [...clients, ...clients];

  return (
    <section className="bg-white py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-10">
        <div className="text-center">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-[0.25em] mb-3">
            Clientes
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 uppercase tracking-tight">
            Confían en <span className="text-amber-600">nosotros</span>
          </h2>
        </div>
      </div>

      <div className="relative">
        <div className="flex animate-scroll">
          {doubled.map((client, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-48 mx-8 flex items-center justify-center grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
            >
              <img
                src={client.src}
                alt={client.alt}
                className="max-h-20 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
